import { analytics, useUser } from 'libs';
import { initialState } from 'state';
import { Select } from 'components/common';
import Filter from './Filter';

interface ProgramRow {
  name: string;
}

interface ProgramFilterProps {
  filters: { programs?: string[] };
  isPro?: boolean;
  onFilter: (update: { programs: string[] | null }) => void;
  size: 'default' | 'lg';
}

interface ProgramOption {
  label: string;
  value: string;
}

const ProgramFilter = ({ filters, isPro = false, onFilter }: ProgramFilterProps) => {
  const { programs } = initialState;
  const user = useUser();
  const disabled = isPro && !user.features.is_pro;

  const exclude = ['Exclusive Rates', 'Limited Feature', 'Promotions', 'Standard Products'];

  const getOptions = (options: ProgramRow[]): ProgramOption[] =>
    options
      .filter((program) => !exclude.includes(program.name))
      .map((program) => ({
        label: program.name,
        value: program.name,
      }));

  const onChange = (selected: ProgramOption[] | null) => {
    const selectedPrograms = selected?.map((option) => option.value) || [];

    const other = exclude.filter((type) => filters.programs?.includes(type));
    const value = [...other, ...selectedPrograms];

    analytics.productSearch.filter({ programs: selectedPrograms.length ? selectedPrograms : 'cleared' });

    onFilter({ programs: value.length ? value : null });
  };

  const options = getOptions(programs);

  const selectedOptions = () => {
    const selectedPrograms = filters.programs || [];

    return selectedPrograms.length ? options.filter((option) => selectedPrograms.includes(option.value)) : null;
  };

  return (
    <Filter
      name="Programs"
      isPro={isPro}
      tooltip={
        <span>
          Each Lender Program groups lender rate cards that address a variety of client situations.
          <br />
          <a
            href="https://support.lenderspotlight.ca/en/articles/4950534-program-definitions"
            rel="noopener noreferrer"
            target="_blank"
          >
            Click for definitions.
          </a>
        </span>
      }
    >
      <Select
        className="form-react-select"
        clearValue={null}
        closeMenuOnSelect={false}
        disabled={disabled}
        isMulti
        onChange={onChange}
        options={options}
        placeholder="All"
        selected={selectedOptions()}
        testId="filter-program"
      />
    </Filter>
  );
};

export default ProgramFilter;
